import { TableFactoryStoreParams } from './types';

export const TABLE_FACTORY_DEFAULT_PARAMS: TableFactoryStoreParams = {
  showNotVisibleByDefaultColumns: false,
};
